<template>
  <section class="form-group tw-space-y-2">
    <h4 v-if="title" class="tw-flex tw-items-center tw-gap-2">
      {{ title }}

      <c-tooltip-standalone v-if="tooltip" size="xs" @click.self="openTooltip"
        ><span v-html="tooltip" />
      </c-tooltip-standalone>
    </h4>
    <h6 v-if="subTitle">{{ subTitle }}</h6>
    <p v-if="description">{{ description }}</p>

    <slot />
  </section>
</template>

<script setup>
const props = defineProps({
  title: String,
  subTitle: String,
  description: String,
  tooltip: String,
  tooltipLink: String,
});

const openTooltip = () => {
  const { tooltipLink } = props;

  if (!tooltipLink) {
    return;
  }

  return window.open(tooltipLink, "_blank");
};
</script>

<style lang="scss">
.form-group {
  @apply tw-mb-4;
}

.meeting-wrapper {
  .form-group {
    @apply tw-mb-12;
  }
}
</style>
